import styled from "styled-components";

const Row = styled.div`
  display: flex;
  /* data error condition */
  opacity: ${({ error }) => (error ? ".5" : "1")};

  & + & { 
    margin-top: 10px;
  }
`;

export default Row;
